<ion-header>
  <ion-toolbar>
    <ion-title *ngIf="type == 'points'">¿Cómo ganar {{configService.company_info.points_name}}?</ion-title>
    <ion-title *ngIf="type == 'ranking'">Ranking</ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="closeModal()">
          <ion-icon name="close"></ion-icon>
        </ion-button>
  </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div *ngIf="type == 'points'" [innerHTML]="text" class="colorBlack htmlContainer"></div>
  <div *ngIf="type == 'ranking'" class="htmlContainer">

    <table mat-table [dataSource]="playerRanking" class="z-depth-1 table">

      <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef> Posicion </th>
        <td mat-cell *matCellDef="let element"> {{element.position}} </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Nombre </th>
        <td mat-cell *matCellDef="let element"> {{element.user.first_name}} {{element.user.last_name}} </td>
      </ng-container>
    
      <ng-container matColumnDef="num_responses">
        <th mat-header-cell *matHeaderCellDef> Misiones aprobadas </th>
        <td mat-cell *matCellDef="let element"> {{element.num_responses}} </td>
      </ng-container>
      
      <ng-container matColumnDef="footer">
        <td mat-footer-cell *matFooterCellDef colspan="3">
          <br>
        </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="['footer']" class="ranking-footer"></tr>
    </table>
  </div>
</ion-content>
